// extracted by mini-css-extract-plugin
export default {"app":"app_app__VBlLf"};